import React from 'react';
import { useLocation } from 'react-router-dom';

export const FiletoBase64 = (file:File) => new Promise((resolve, reject) => {
    if (file === null) return resolve('');
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
};
